import {
  LiveStatsContent,
  NormalBrowseFileInputFiled,
  NormalColorInputField,
  NormalTextEditorInputFiled,
  NormalTextInputField,
} from "@/components";
import { useMemo } from "react";

const HomeAboutUsSectionFormField = ({
  activeLang,
  isFetching,
  allFilesResponse,
  searchValue,
  selectedFileType,
  onChangeImage,
  handleTextInputChange,
  stateDetails,
  adminRole,
  permissionsList,
}) => {
  const isHideInOtherLanguages = useMemo(() => {
    return activeLang === "en";
  }, [activeLang]);

  const getSelectedBannerImageId = (id) => {
    if (id) {
      onChangeImage("home-section-2-about-company-image", id);
    } else {
      onChangeImage("home-section-2-about-company-image", "");
    }
  };

  return (
    <>
      {/* Heading */}
      <NormalTextInputField
        isFetching={isFetching}
        labelText="Heading"
        fieldId="home-section-2-about-company-heading"
        fieldName="home-section-2-about-company-heading"
        placeholderText="Heading"
        inputValue={
          stateDetails?.["home-section-2-about-company-heading"] || ""
        }
        onChangeTextInputField={handleTextInputChange}
        extraContainerClasses="mb-5"
        translateField={true}
      />

      {/* Description */}
      <NormalTextInputField
        isFetching={isFetching}
        isTextArea={true}
        labelText="Description"
        fieldId="home-section-2-about-company-description"
        fieldName="home-section-2-about-company-description"
        placeholderText="Description"
        inputValue={
          stateDetails?.["home-section-2-about-company-description"] || ""
        }
        onChangeTextInputField={handleTextInputChange}
        extraContainerClasses="mb-5"
        translateField={true}
      />

      {/* About Company Image */}
      {isHideInOtherLanguages && (
        <NormalBrowseFileInputFiled
          isFetching={isFetching}
          labelText="Image"
          fieldId="home-section-2-about-company-image"
          allFilesResponse={allFilesResponse}
          searchValue={searchValue}
          selectedFileType={selectedFileType}
          onChangeImageFunction={getSelectedBannerImageId}
          selectedFileId={
            stateDetails?.["home-section-2-about-company-image"] || ""
          }
          adminRole={adminRole}
          permissionsList={permissionsList}
          extraContainerClasses="mb-5"
        />
      )}

      {/* Iamge Title */}
      <NormalTextInputField
        isFetching={isFetching}
        labelText="Image Title"
        fieldId="home-section-2-about-company-image-title"
        fieldName="home-section-2-about-company-image-title"
        placeholderText="Image Title"
        inputValue={
          stateDetails?.["home-section-2-about-company-image-title"] || ""
        }
        onChangeTextInputField={handleTextInputChange}
        extraContainerClasses="mb-5"
        translateField={true}
      />

      {/* Image Description */}
      <NormalTextInputField
        isFetching={isFetching}
        isTextArea={true}
        labelText="Image Description"
        fieldId="home-section-2-about-company-image-description"
        fieldName="home-section-2-about-company-image-description"
        placeholderText="Image Description"
        inputValue={
          stateDetails?.["home-section-2-about-company-image-description"] || ""
        }
        onChangeTextInputField={handleTextInputChange}
        extraContainerClasses="mb-5"
        translateField={true}
      />

      {/* Button Label */}
      <NormalTextInputField
        isFetching={isFetching}
        labelText="Button Label"
        fieldId="home-section-2-about-company-button-label"
        fieldName="home-section-2-about-company-button-label"
        placeholderText="Button Label"
        inputValue={
          stateDetails?.["home-section-2-about-company-button-label"] || ""
        }
        onChangeTextInputField={handleTextInputChange}
        extraContainerClasses="mb-5"
        translateField={true}
      />
    </>
  );
};

export default HomeAboutUsSectionFormField;
